import React, { createContext, useContext, useState, useEffect } from "react";

const CompareContext = createContext(null);
export const useCompare = () => {
  const c = useContext(CompareContext);
  if (!c) throw new Error("useCompare must be used within CompareProvider");
  return c;
};

const MAX = 3;
const LS = "bud_compare_ids";

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(LS);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(LS, JSON.stringify(items));
  }, [items]);

  const has = (id) => items.some((p) => p.id === id);
  const toggle = (product) =>
    setItems((cur) => {
      if (cur.some((p) => p.id === product.id)) {
        return cur.filter((p) => p.id !== product.id);
      }
      if (cur.length >= MAX) return cur;
      return [...cur, product];
    });
  const remove = (id) => setItems((cur) => cur.filter((p) => p.id !== id));
  const clear = () => setItems([]);

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, has, MAX }}>
      {children}
    </CompareContext.Provider>
  );
};
